import React from 'react'
import logo from '../../styles/images/logo-white.svg'
import { Link } from 'react-router-dom'

const SignForm = props => (
  <section className='sign-form inner-wrapper'>
    <div className='logo'>
      <Link to='/explore'>
        <img src={logo} alt='Chairbids Logo' />
      </Link>
    </div>
    {props.children}
  </section>
)

export default SignForm



// WEBPACK FOOTER //
// ./src/ui/shared/sign-form.js